import React, { Component } from "react";
import ToRestorePassword from "./ToResorePassword/ToRestorePassword";
import RestorePassword from "./RestorePassword/RestorePassword";

class SwitchRestore extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    const toRestore = window.location.search === "";

    if (toRestore) {
      return <ToRestorePassword />;
    } else {
      return <RestorePassword />;
    }
  }
}

export default SwitchRestore;
